import { gql } from '@apollo/client';
import espotFragment from '../../../queries/fragments/Espot';
import facetDataFragment from '../../../queries/fragments/Facets';
import paginationFragment from '../../../queries/fragments/Pagination';
import sortDataFragment from '../../../queries/fragments/ProductGridHeaderCoreFields';
import productsFragment from '../../../queries/fragments/Products';

const CATEGORY_PAGE_STATIC_DATA_QUERY = gql`
  query CATEGORY_PAGE_STATIC_DATA_QUERY (
    $useExcludeCategoryHeroEspot: Boolean!
  ) {
      config {
        enableXhrNav: genericType(name: "enableXhrNav")
        hasCatalogMfeEspots: genericType(name: "hasCatalogMfeEspots")
        hasShopMyStoreEnabled: genericType(name: "hasLISFilter")
        excludeCategoryHeroEspot: genericType(name: "excludeCategoryHeroEspot") @include(if: $useExcludeCategoryHeroEspot)
        enableExposedFiltersAndCategories: genericType(name: "enableExposedFiltersAndCategories")
      }
  }
`;

const CATEGORY_PAGE_DYNAMIC_DATA_QUERY = gql`
  ${facetDataFragment}
  ${productsFragment}
  ${espotFragment}
  ${paginationFragment}
  ${sortDataFragment}
  query CATEGORY_PAGE_DYNAMIC_DATA_QUERY(
    $categoryId: String!,
    $facet: [String],
    $filter: String,
    $requestSocialProofData: Boolean,
    $rows: String!,
    $skipProductsCache: Boolean,
    $sort: String,
    $start: String!,
    $seqSlot: String,
    $skipSubCategoriesCache: Boolean,
    $grouped: Boolean! 
    $isUnifiedCategoryPage: Boolean!
    $kicIds: String
    ) {
      groupedCategory (
        categoryId: $categoryId,
        facet: $facet,
        filter: $filter,
        requestSocialProofData: $requestSocialProofData,
        rows: $rows,
        sort: $sort,
        start: $start,
        seqSlot: $seqSlot
      ) @include(if: $grouped) {
        name
        categoryId
        pagination {
          ...PaginationInfo
        }
        productTotalCount
        subCategories(cacheEmpty: false, skipCache: $skipSubCategoriesCache) {
          categoryId
          name
          products {
            ...Products
            socialProofMessage
          }
          ...Espot
        }
      }
    
      category (
        categoryId: $categoryId,
        facet: $facet,
        filter: $filter,
        kicIds: $kicIds,
        requestSocialProofData: $requestSocialProofData,
        rows: $rows,
        sort: $sort,
        start: $start,
        seqSlot: $seqSlot,
      ) {
        categoryId
        facets {
          ...Facets
        }
        marketingBackground {
          portrait
          landscape
          fallback
        }
        navParentCategoryId
        name
        popularSearches {
          name
          url
        }
        title
        url
        pagination {
          ...PaginationInfo
        }
        productTotalCount
        products(cacheEmpty: false, skipCache: $skipProductsCache) {
          ...Products
          socialProofMessage
        }
        ...Espot
        espotIdentifier @include(if: $isUnifiedCategoryPage)
        sortData {
          ...SortData
        }
        breadcrumbTrailEntryView {
          label
          value
          url
        }
        fullCatHead
      }
  }
`;

export {
  CATEGORY_PAGE_STATIC_DATA_QUERY,
  CATEGORY_PAGE_DYNAMIC_DATA_QUERY,
};
